import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {Vision} from '../message/Vision';
import {VisionCriteria} from './VisionCriteria';
import {VisionScenario} from './VisionScenario';

export class VisionWrapper extends BaseWrapper<Vision, VisionCriteria, VisionScenario>  {}

